export default {
  cardStyle: {
    width: "20%",
    margin: "1rem",
    height: "9rem",
    minWidth: "15rem",
  },
};
